export default __webpack_public_path__ + "static/media/img-0075-uk-premium-face.e8eb78c8.png";